
  export default {
    meta: {
      breadcrumbs: [['i18n/home', '/', 'mobile'], 'i18n/terms']
    },
    middleware: ['pages/terms', 'breadcrumbs', 'meta-tags']
  };
